import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import pt_BR from './languages/pt-BR.json';
import en_US from './languages/en-US.json';
import es_AR from './languages/es-AR.json';
import agrofly from './languages/agrofly.json';
import bobton from './languages/bobton.json';


i18n.use(initReactI18next).init({
  resources: {
    en_US: {
      translation: en_US              
    },
    pt_BR: {
      translation: pt_BR
    },
    "pt-BR": {
      translation: pt_BR
    },
    es_AR: {
      translation: es_AR
    },
    agrofly: {
      translation: agrofly
    },
    bobton: {
      translation: bobton
    }
  },
  lng: "pt_BR",
  fallbackLng: "pt_BR",

  interpolation: {
    escapeValue: false
  }
})

export default i18n;